"use client";

import { useState, useCallback, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteUserActionManager,
  getAllUsersAction,
  updateUserActionManager,
} from "../../../../services/action/manager";
import CustomModal from "../../../utils/modals/CustomModal";
import FormEditClient from "./components/FormEditClient";
import DeleteConfirmation from "../../../utils/dialoge/DeleteConfirmation";
import FullScreenModal from "../../../utils/modals/FullScreenModal";
import PersonalCard from "../../../card/PersonalCard";
import UpdateReferalAmount from "./components/UpdateReferalAmount";
import {
  Plus,
  User,
  Mail,
  Briefcase,
  ChevronDown,
  Users,
  Menu,
} from "lucide-react";
import socket from "../../../socket/socket";
import { handlePopupModalAction } from "../../../../services/action/event";

const ClientListComponent = ({
  // getList,
  // TeamsData,
  listTitle = "Client List",
  listType = "CLIENT",
  // setPageData,
  // pageData,
  // isWhatsAppClient,
  // setIsWhatsAppClient,
}) => {
  const [pageData, setPageData] = useState({
    page: 1,
    limit: 15,
  });
  const { userList: TeamsData } = useSelector((state) => state.managerReducer);
  const [search, setSearch] = useState("");
  const { isDeleteUser } = useSelector((state) => state.managerReducer);
  const { user } = useSelector((state) => state.authenticationReducer);
  const dispatch = useDispatch();
  const [firstTimeRender, setFirstTimeRender] = useState(false);
  const [operatorDetail, setOperatorDetail] = useState({
    modal: false,
    preview: false,
    edit: false,
    data: "",
  });
  const [isWhatsAppClient, setIsWhatsAppClient] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [referalUser, setReferalUser] = useState("");
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0
  );

  const getList = ({
    limit = pageData.limit,
    currentPage,
    firstTime = true,
    keyword = search,
    tempIsWhatsAppClient = isWhatsAppClient,
  }) => {
    dispatch(
      getAllUsersAction({
        userType: user?.userType,
        firstTime,
        data: {
          userType: "client",
          page: currentPage,
          limit,
          keyword,
          isWhatsAppClient: !!tempIsWhatsAppClient,
        },
      })
    );
  };
  // useEffect(() => {
  //   getList({ currentPage: 1, firstTime: true });
  // }, []);

  useEffect(() => {
    socket.on("internal_user_activity", ({ userType }) => {
      if (userType == listType) {
        getList({
          firstTime: true,
          limit: pageData?.limit * pageData?.page,
          currentPage: 1,
        });
      }
    });
    return () => {
      socket.off("internal_user_activity");
    };
  }, [getList, pageData?.limit, pageData?.page]);
  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    if (typeof window !== "undefined") {
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }
  }, []);

  const observer = useRef(null);
  const loadingRef = useRef(null);

  useEffect(() => {
    if (TeamsData?.data?.length >= TeamsData?.pagination?.total) {
      setHasMore(false);
    } else {
      setHasMore(true);
    }
  }, [TeamsData?.data?.length, TeamsData?.totalResults]);

  const fetchMoreData = useCallback(() => {
    if (loading || !hasMore) return;

    setLoading(true);

    try {
      getList({ currentPage: pageData?.page + 1, firstTime: false });

      setPageData((prev) => ({ ...prev, page: prev?.page + 1 }));
    } catch (error) {
      console.error("Error fetching more data:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  }, [loading, hasMore, pageData?.page, getList, setPageData]);

  // Set up and clean up the IntersectionObserver
  useEffect(() => {
    // Disconnect any existing observer
    if (observer.current) {
      observer.current.disconnect();
    }

    // Function to handle intersection
    const handleIntersection = (entries) => {
      // Only fetch more data if:
      // 1. The loading element is intersecting
      // 2. We have more data to load
      // 3. We're not currently loading
      if (entries[0].isIntersecting && hasMore && !loading && firstTimeRender) {
        fetchMoreData();
      }
    };

    // Create a new observer
    observer.current = new IntersectionObserver(handleIntersection, {
      root: null,
      rootMargin: "100px", // Load a bit before reaching the bottom
      threshold: 0.1, // Trigger when at least 10% of the element is visible
    });

    // Start observing the loading element
    if (loadingRef.current) {
      observer.current.observe(loadingRef.current);
    }

    // Clean up
    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, [fetchMoreData, hasMore, loading]);

  const afterSave = () => {
    getList({ currentPage: 1, isEmptylist: false });
    setOperatorDetail({});
  };

  const deleteFinal = () => {
    const userType = user?.userType?.toLowerCase();
    dispatch(
      deleteUserActionManager({
        userType,
        data: deleteId,
        cb: () => {
          setDeleteId("");
          getList({ currentPage: 1, isEmptylist: false });
          setOperatorDetail({});
        },
      })
    );
  };

  const updateStatus = (data) => {
    const userType = user?.userType?.toLowerCase();
    dispatch(
      updateUserActionManager({
        userType,
        data: {
          _id: data?._id,
          status: data?.status === "ACTIVE" ? "NOT ACTIVE" : "ACTIVE",
        },
        cb: () => getList({ currentPage: 1, isEmptylist: false }),
      })
    );
  };
  const onSearch = (keyword) => {
    setPageData({ page: 1 });
    setSearch(keyword);
    getList({ currentPage: 1, firstTime: true, keyword: keyword });
  };

  useEffect(() => {
    if (!firstTimeRender) {
      getList({ currentPage: 1, firstTime: true });
      setTimeout(() => {
        setFirstTimeRender(true);
      }, [3000]);
    }
  }, [firstTimeRender]);
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-100 to-gray-200 text-gray-900 p-2 sm:p-4">
      <div className="rounded-lg overflow-hidden bg-white shadow-xl">
        {deleteId && (
          <DeleteConfirmation
            open={deleteId}
            isDeleteLoading={isDeleteUser}
            onClose={() => setDeleteId("")}
            onConfirm={deleteFinal}
          />
        )}

        <CustomModal
          title={listType === "MARKETING" ? "Add Marketing Team" : "Add Client"}
          open={operatorDetail.modal}
          onClose={() => setOperatorDetail({})}
          content={() => (
            <FormEditClient
              listType={listType}
              data={operatorDetail?.data}
              close={afterSave}
            />
          )}
        />

        <CustomModal
          content={() => (
            <UpdateReferalAmount
              getList={getList}
              setReferalUser={setReferalUser}
              referalUser={referalUser}
            />
          )}
          onClose={() => setReferalUser("")}
          open={referalUser}
        />

        <FullScreenModal
          title="Personal Details"
          open={operatorDetail.preview}
          onClose={() => setOperatorDetail({})}
          content={() => (
            <PersonalCard
              onDeleteClick={(data) => setDeleteId(data)}
              onEditClick={(data) =>
                setOperatorDetail({
                  edit: true,
                  modal: true,
                  preview: false,
                  data,
                })
              }
              data={operatorDetail?.data}
              close={() => setOperatorDetail({})}
            />
          )}
        />

        <div className="p-3 sm:p-4 border-b border-gray-200 bg-white">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-4">
            <div className="flex items-center gap-2 w-full justify-center sm:justify-start">
              <button
                onClick={() =>
                  dispatch(handlePopupModalAction({ isOpenSidebar: true }))
                }
                className="mr-4 p-2 hover:text-[#fff]  rounded-md hover:bg-[#0A2547] lg:hidden"
              >
                <Menu className="w-6 h-6" />
              </button>
              <h2 className="text-xl sm:text-2xl font-bold text-gray-800 bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-purple-600">
                {listTitle}
              </h2>
              <div className="flex items-center gap-1 bg-blue-50 px-2 py-1 rounded-full">
                <Users className="w-3 h-3 text-blue-500" />
                <span className="text-xs font-medium text-blue-700">
                  Total: {TeamsData?.pagination?.total || 0}
                </span>
              </div>
            </div>
            <div className="flex flex-row gap-2 w-full justify-between sm:justify-end">
              <div className="relative flex-1 max-w-xs">
                <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="text-gray-400"
                  >
                    <circle cx="11" cy="11" r="8"></circle>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="Search..."
                  value={search}
                  onChange={(e) => onSearch(e.target.value)}
                  className="w-full h-8 pl-7 pr-7 py-1 text-xs rounded-full border border-gray-200 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                />
                {search && (
                  <button
                    onClick={() => setSearch("")}
                    className="absolute inset-y-0 right-0 pr-2 flex items-center text-gray-400 hover:text-gray-600"
                    aria-label="Clear search"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="18" y1="6" x2="6" y2="18"></line>
                      <line x1="6" y1="6" x2="18" y2="18"></line>
                    </svg>
                  </button>
                )}
              </div>
              <button
                onClick={() => setOperatorDetail({ modal: true, edit: false })}
                className="px-3 py-1.5 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-full text-xs sm:text-sm font-medium flex items-center justify-center gap-1 transition-all duration-300 shadow-md hover:shadow-lg"
              >
                <Plus className="w-3 h-3 sm:w-4 sm:h-4" />
                <span>
                  {listType === "MARKETING" ? "Add Marketing" : "Add Client"}
                </span>
              </button>
              <div className="flex items-center gap-1 sm:gap-2">
                <span
                  className={`text-xs sm:text-sm ${
                    isWhatsAppClient
                      ? "text-blue-600 font-medium"
                      : "text-gray-600"
                  }`}
                >
                  {windowWidth < 640 ? "WhatsApp" : "Show WhatsApp Client"}
                </span>
                <label className="relative inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={isWhatsAppClient}
                    onChange={() => {
                      getList({
                        currentPage: 1,
                        firstTime: true,
                        tempIsWhatsAppClient: !isWhatsAppClient,
                      });
                      setIsWhatsAppClient(!isWhatsAppClient);
                    }}
                  />
                  <div
                    className={`
                      w-8 sm:w-11 h-5 sm:h-6 
                      rounded-full 
                      peer 
                      transition-all
                      duration-200
                      shadow-inner
                      ${
                        isWhatsAppClient
                          ? "bg-gradient-to-r from-blue-400 to-blue-600"
                          : "bg-gray-200"
                      }
                      after:content-[''] 
                      after:absolute 
                      after:top-[2px] 
                      after:left-[2px] 
                      after:bg-white 
                      after:rounded-full 
                      after:h-4 sm:after:h-5 
                      after:w-4 sm:after:w-5 
                      after:shadow-md
                      after:transition-all
                      after:duration-300
                      peer-checked:after:translate-x-full
                      ${
                        isWhatsAppClient
                          ? "after:border-blue-200"
                          : "after:border-gray-200"
                      }
                    `}
                  ></div>
                </label>
              </div>
            </div>
          </div>
        </div>

        {/* Stats Card */}
        <div className="p-2 sm:p-4 bg-white border-b border-gray-100">
          <div className="grid grid-cols-3 gap-2 sm:gap-4">
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-2 sm:p-3 flex items-center justify-between shadow-sm">
              <div>
                <p className="text-xs sm:text-sm text-blue-600 font-medium">
                  Total
                </p>
                <h3 className="text-base sm:text-xl font-bold text-gray-800">
                  {TeamsData?.pagination?.total || 0}
                </h3>
                <p className="text-[10px] sm:text-xs text-gray-500 hidden sm:block">
                  {isWhatsAppClient ? "WhatsApp" : "All"}
                </p>
              </div>
              <div className="bg-blue-100 p-1.5 sm:p-2 rounded-full">
                <Users className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600" />
              </div>
            </div>

            <div className="bg-gradient-to-r from-green-50 to-emerald-50 rounded-lg p-2 sm:p-3 flex items-center justify-between shadow-sm">
              <div>
                <p className="text-xs sm:text-sm text-green-600 font-medium">
                  Active
                </p>
                <h3 className="text-base sm:text-xl font-bold text-gray-800">
                  {TeamsData?.pagination?.activeUsers}
                </h3>
                <p className="text-[10px] sm:text-xs text-gray-500 hidden sm:block">
                  In system
                </p>
              </div>
              <div className="bg-green-100 p-1.5 sm:p-2 rounded-full">
                <User className="w-4 h-4 sm:w-5 sm:h-5 text-green-600" />
              </div>
            </div>

            <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg p-2 sm:p-3 flex items-center justify-between shadow-sm">
              <div>
                <p className="text-xs sm:text-sm text-purple-600 font-medium">
                  Online
                </p>
                <h3 className="text-base sm:text-xl font-bold text-gray-800">
                  {TeamsData?.pagination?.onlineUsers}
                </h3>
                <p className="text-[10px] sm:text-xs text-gray-500 hidden sm:block">
                  Right now
                </p>
              </div>
              <div className="bg-purple-100 p-1.5 sm:p-2 rounded-full">
                <div className="relative">
                  <User className="w-4 h-4 sm:w-5 sm:h-5 text-purple-600" />
                  <div className="absolute -top-1 -right-1 w-2 h-2 sm:w-2.5 sm:h-2.5 bg-green-500 rounded-full border-2 border-white"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50 sticky top-0 z-10">
              <tr>
                {[
                  "Status",
                  "Sr.",
                  "Contact",
                  "Image",
                  "Name",
                  "Email",
                  "Wallet",
                  "Role",
                  "Active",
                ]
                  .filter(Boolean)
                  .map((header, index) => (
                    <th
                      key={index}
                      className="px-2 sm:px-3 py-2 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider"
                    >
                      <div className="flex items-center gap-1">
                        {windowWidth < 640 && header.length > 4
                          ? header.substring(0, 4) + "..."
                          : header}
                        <ChevronDown className="w-3 h-3" />
                      </div>
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {TeamsData?.data?.map((client, index) => (
                <tr
                  key={client._id}
                  className="bg-white hover:bg-gray-50 transition-all duration-300"
                >
                  <td className="px-2 sm:px-3 py-2 whitespace-nowrap">
                    <div
                      className={`flex items-center gap-1 ${
                        client.isOnline ? "text-green-600" : "text-red-600"
                      }`}
                    >
                      <div
                        className={`w-2 h-2 rounded-full ${
                          client.isOnline ? "bg-green-500" : "bg-red-500"
                        }`}
                      />
                      <span className="text-xs font-medium hidden sm:inline">
                        {client.isOnline ? "Online" : "Offline"}
                      </span>
                    </div>
                  </td>
                  <td className="px-2 sm:px-3 py-2 whitespace-nowrap text-xs text-gray-700">
                    {index + 1}
                  </td>
                  <td className="px-2 sm:px-3 py-2 whitespace-nowrap text-xs">
                    {client?.contactDetails?.length ? (
                      <span className="px-1 sm:px-2 py-1 inline-flex text-xs leading-4 font-semibold rounded-full bg-green-100 text-green-800">
                        {windowWidth < 640 ? "Y" : "Saved"}
                      </span>
                    ) : (
                      <span className="px-1 sm:px-2 py-1 inline-flex text-xs leading-4 font-semibold rounded-full bg-yellow-100 text-yellow-800">
                        {windowWidth < 640 ? "N" : "Not Saved"}
                      </span>
                    )}
                  </td>
                  <td className="px-2 sm:px-3 py-2 whitespace-nowrap">
                    <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-full overflow-hidden border border-gray-200 transition-transform duration-300 hover:scale-110 hover:border-blue-500">
                      <img
                        src={client.image || "/placeholder.svg"}
                        alt=""
                        className="w-full h-full object-cover"
                      />
                    </div>
                  </td>
                  <td className="px-2 sm:px-3 py-2 whitespace-nowrap">
                    <button
                      onClick={() =>
                        setOperatorDetail({
                          data: client,
                          preview: true,
                          modal: false,
                        })
                      }
                      className="text-xs text-blue-600 hover:text-blue-800 font-medium transition-colors duration-200 flex items-center gap-1 hover:underline max-w-[80px] sm:max-w-full truncate"
                    >
                      <User className="w-3 h-3 flex-shrink-0" />
                      <span className="truncate">{client?.name || "NA"}</span>
                    </button>
                  </td>
                  <td className="px-2 sm:px-3 py-2 whitespace-nowrap text-xs text-gray-700">
                    <div className="flex items-center gap-1 max-w-[80px] sm:max-w-full">
                      <Mail className="w-3 h-3 text-gray-400 flex-shrink-0" />
                      <span className="truncate">{client?.email || "NA"}</span>
                    </div>
                  </td>
                  <td className="px-2 sm:px-3 py-2 whitespace-nowrap">
                    <button
                      onClick={() => setReferalUser(client)}
                      className="text-xs text-blue-600 hover:text-blue-800 font-medium transition-colors duration-200 flex items-center gap-1 hover:underline"
                    >
                      ${client?.wallet?.amount || 0}
                    </button>
                  </td>
                  <td className="px-2 sm:px-3 py-2 whitespace-nowrap text-xs text-gray-700">
                    <div className="flex items-center gap-1 max-w-[60px] sm:max-w-full">
                      <Briefcase className="w-3 h-3 text-gray-400 flex-shrink-0" />
                      <span className="truncate">
                        {client?.userType || "NA"}
                      </span>
                    </div>
                  </td>
                  <td className="px-2 sm:px-3 py-2 whitespace-nowrap">
                    <label className="relative inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={client.status === "ACTIVE"}
                        onChange={() => updateStatus(client)}
                      />
                      <div
                        className={`
                          w-8 sm:w-11 h-5 sm:h-6 
                          rounded-full 
                          peer 
                          transition-all
                          duration-200
                          shadow-inner
                          ${
                            client.status === "ACTIVE"
                              ? "bg-gradient-to-r from-green-400 to-green-600"
                              : "bg-gray-200"
                          }
                          after:content-[''] 
                          after:absolute 
                          after:top-[2px] 
                          after:left-[2px] 
                          after:bg-white 
                          after:rounded-full 
                          after:h-4 sm:after:h-5 
                          after:w-4 sm:after:w-5 
                          after:shadow-md
                          after:transition-all
                          after:duration-300
                          peer-checked:after:translate-x-full
                          ${
                            client.status === "ACTIVE"
                              ? "after:border-green-200"
                              : "after:border-gray-200"
                          }
                        `}
                      ></div>
                    </label>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div ref={loadingRef} className="text-center py-4">
            {loading && (
              <div className="inline-block animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-blue-500"></div>
            )}
            {!hasMore && TeamsData?.data?.length > 0 && (
              <div className="text-gray-500 text-sm">No more data to load</div>
            )}
            {!loading && TeamsData?.data?.length === 0 && (
              <div className="text-gray-500 text-sm py-4">
                No data available
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientListComponent;
